// removed by extract-text-webpack-plugin
module.exports = {"avatar":"_3TmQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Avatar/Avatar.scss
// module id = jG1r
// module chunks = 0